import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Modals from "../../../../components/modal";
import DeleteConfirmation from "../../../../components/delete-confirmation";
import { useDeleteReportOption } from "./hooks";

const DeleteReason = ({ option }) => {
  const {
    handledeleteReportOption,
    isOpenModal,
    toggleModal,
    deleteReportOptionLoading,
  } = useDeleteReportOption(option);

  return (
    <>
      <Tooltip title="Delete" placement="bottom">
        <i
          className={`fa fa-trash icon-btn-action text-danger`}
          onClick={toggleModal}
        ></i>
      </Tooltip>
      {isOpenModal ? (
        <Modals
          isOpenModal
          setIsOpenModal={toggleModal}
          message={
            <DeleteConfirmation
              message="Are you sure you want to delete?"
              handleDelete={handledeleteReportOption}
              isLoading={deleteReportOptionLoading}
            />
          }
          title="Delete Reason"
        />
      ) : null}
    </>
  );
};

export default DeleteReason;
